import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import { PlanLevel } from '@ninety/platform/models/billing/plan-level';
import { BillingStateActions } from '@ninety/platform/state/app-global/billing/billing-state.actions';
import { TerraIconModule } from '@ninety/terra';
import { NinetyCMModule } from '@ninety/ui/core';
import { FilterBarActions } from '@ninety/web/pages/shared/layouts';

@Component({
  selector: 'ninety-one-on-one-tiered-page',
  standalone: true,
  imports: [TerraIconModule, NinetyCMModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: ` <!---->
    <ninety-cm-tiered-page>
      <div headline>Foster Stronger Connections</div>
      <div description>Unlock the 1-on-1 feature to ensure regular, meaningful conversations with your team.</div>
      <button ninety-cm-button (click)="onCTAClick()">
        <terra-icon icon="lightning" variant="fill" />
        Explore {{ pricingTierEnum.Accelerate }} Plan
      </button>
    </ninety-cm-tiered-page>`,
})
export class OneOnOneTieredPageComponent {
  private readonly store = inject(Store);

  pricingTierEnum = PlanLevel;

  constructor() {
    this.store.dispatch(FilterBarActions.hide());
  }

  onCTAClick() {
    this.store.dispatch(BillingStateActions.openPricingPlansModal());
  }
}
